import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const useStyles = makeStyles((theme: Theme) => ({
  actions: {
    padding: "16px 24px",
  },

  closeButton: {
    color: colors.gray500,
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },

  content: {
    padding: "32px 24px",
  },

  dialog: {
    "& .MuiPaper-rounded": {
      borderRadius: "12px",
    },
  },

  title: {
    padding: "24px 24px 0px 24px",

    "& .MuiTypography-root": {
      color: colors.gray600,
      fontFamily: "Manrope",
      fontSize: "22px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "28px", //* 127.273% */
    },
  },
}));
